/** Normalize for storage / ANPR: remove spaces, dashes, dots; uppercase. */
export function normalizeVehiclePlate(raw: string): string {
  return String(raw || "")
    .replace(/[\s\-_.]/g, "")
    .toUpperCase();
}

/** 6–12 alphanumeric (typical IN-style plates after normalization). */
export function isValidVehiclePlateFormat(normalized: string): boolean {
  if (!normalized || normalized.length < 6 || normalized.length > 12) {
    return false;
  }
  return /^[A-Z0-9]+$/.test(normalized);
}
